module.exports = __webpack_public_path__ + "img/ic_16_drilldown.93e22d16.svg";